
import { CslEndNoteCitation } from '@/jbi-shared/types/citation.fields';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class UploadComplete extends Vue {
  @Prop(String) private fileName!: string;

  @Prop() private importSummary!: {
    success: number;
    failed: number;
    total: number;
    failedEntries: CslEndNoteCitation[];
  };
}
